import { MaterialIcons } from '@expo/vector-icons';
import { Pressable } from 'react-native';
import { SizableText, useTheme, YStack } from 'tamagui';
import { UploadedFileItem } from './UploadedFileItem';
import type { FileUploaderFieldProps } from './fileUploaderField.types';

export const FileUploaderField = ({
  files,
  multiple = true,
  helperText,
  uploadPrompt,
  errorMessage,
  onUploadPress,
  onRemoveFile,
}: FileUploaderFieldProps): React.ReactElement => {
  const theme = useTheme();
  const shouldShowUploadArea = multiple || files.length === 0;

  return (
    <YStack gap="$3">
      {shouldShowUploadArea && (
        <Pressable onPress={onUploadPress}>
          <YStack
            borderWidth={1}
            borderColor="$borderColor"
            borderStyle="dashed"
            backgroundColor="$tertiary50"
            padding="$4"
            alignItems="center"
            gap="$3"
          >
            <YStack
              backgroundColor="$tertiary"
              padding="$3"
              borderRadius="$circle"
            >
              <MaterialIcons
                name="upload-file"
                size={24}
                color={theme.color?.val}
              />
            </YStack>
            <SizableText size="$2" fontFamily="$bold" textAlign="center">
              {uploadPrompt}
            </SizableText>
            {helperText && (
              <SizableText size="$2" color="$secondary75" textAlign="center">
                {helperText}
              </SizableText>
            )}
          </YStack>
        </Pressable>
      )}

      {files.length > 0 && (
        <YStack gap="$2">
          {files.map((file) => (
            <UploadedFileItem
              key={file.id}
              file={file}
              onRemove={() => onRemoveFile(file.id)}
            />
          ))}
        </YStack>
      )}

      {errorMessage && (
        <SizableText size="$1" color="$error">
          {errorMessage}
        </SizableText>
      )}
    </YStack>
  );
};
